
<template>
  <el-container class="courseMobile">
    <el-header>
      <div class="head-top">
        <img
          class="logo"
          src="../assets/logo_white.png">
      </div>
    </el-header>
      <el-main>
        <h3>Courses Schedule</h3>
        <div class="filtersBtn">
          <el-button @click="openFilter"><i class="icon-filter"></i>Filters</el-button>
        </div>
        <div class="popoverBox" v-if="isShow">
          <div class="searchBox">
            <div class="btnBox">
              <p @click="openFilter" class="el-icon-close"></p>
              <h3>Filters</h3>
              <p @click="reset">Reset</p>
            </div>
            <div>
              <p>Subject</p>
              <el-select v-model="valueSubject" @change="search" clearable placeholder="Select a Subject">
              <el-option v-for="item in SubOptions"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">{{item.title}}
                </el-option>
              </el-select>
            </div>
            <div>
              <p>Day in week</p>
              <el-checkbox-group v-model="valueWeek">
                <el-checkbox
                  v-for="item in weekOptions"
                  :key="item.id"
                  :label="item.id"
                  :value="item.id"
                   name="weekday"
                  >{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div>
              <p>Level</p>
              <el-select v-model="valueLevel" clearable placeholder="Please Select">
                <el-option
                  v-for="item in levelOptions"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">{{item.title}}
                </el-option>
              </el-select>
            </div>
            <div>
              <p>Frequency</p>
              <el-select v-model="valueFrequency" clearable placeholder="Please Select">
                <el-option
                  v-for="item in frequencyOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">{{item.name}}
                </el-option>
              </el-select>
            </div>
            <div>
              <el-button @click="apply">Apply Filters</el-button>
            </div>
          </div>
        </div>
      </el-main>
      <div class="mainContent">
        <div class="courseList">
          <div class="listInfo" v-for="(item, i) in courseData" :key="i">
            <div class="courseTitle">
              <div class="subject_img">
                <p><img :src="item.subject_img" alt="">{{item.subject_title}}</p>
                <span><i>Course ID: {{item.course_id}}</i>
                <i>({{item.level_title}})</i></span>
              </div>
              <div>
                <p><i>Level </i>{{item.level_group_title}}</p>
              </div>
              <div class="perCourse">
                <div>
                  <i>Weekly schedule:</i>
                  <p v-for="(d, j) in item.date_time" :key="j">{{d.split('-')[0]}} - <b>{{d.split('-')[1]}}</b></p>
                </div>
                <div class="flex_center">
                  <p v-for="(w, k) in weekOptions" :key="k" v-if="item.weekday.indexOf(w.id)>-1">
                    <img :src="w.img_act" alt="">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
  </el-container>
</template>
<script>
import IndexHeader from './views/header'
export default {
  components: {
    IndexHeader
  },
  data () {
    return {
      courseData: [],
      SubOptions: [],
      levelOptions: [],
      weekOptions:[
        {
          title:'M',
          name:'Monday',
          id:1,
          img_act:require('../assets/m_active.svg'),
        },
        {
          title:'T',
          name:'Tuesday',
          id:2,
          img_act:require('../assets/t_active.svg'),
        },
        {
          title:'W',
          name:'Wedesday',
          id:3,
          img_act:require('../assets/w_active.svg'),
        },
        {
          title:'Th',
          name:'Thursday',
          id:4,
          img_act:require('../assets/th_active.svg'),
        },
        {
          title:'F',
          name:'Friday',
          id:5,
          img_act:require('../assets/f_active.svg'),
        },
        {
          title:'Sa',
          name:'Saturday',
          id:6,
          img_act:require('../assets/sa_active.svg'),
        },
        {
          title:'Su',
          name:'Sunday',
          id:0,
          img_act:require('../assets/su_active.svg'),
        }
      ],
      frequencyOptions:[
        {
          id:'',
          name:'All',
        },
        {
          id:'1',
          name:'1 lesson per week',
        },
        {
          id:'2',
          name:'2 lessons per week',
        },
        {
          id:'3',
          name:'3 lessons per week',
        }
      ],
      valueSubject:'',
      valueLevel:'',
      valueWeek:[1,2,3,4,5,6,0],
      valueFrequency:'',
      pageSize:10,
      pageNum:1,
      total:1,
      seach:'',
      isShow:false
    }
  },
  created () {
    this.getSubjects()
  },
  mounted() {
      window.addEventListener('scroll', this.loading, true);
      // window.addEventListener('touchmove', this.loading, true);
  },
  destroyed() {
      window.removeEventListener("scroll", this.loading, true);
  },
  methods:{
    getSubjects () {
      this.$http.get('/api/getSubject').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.SubOptions = res.data.data
          // this.getlevelsData()
          // this.search(this.SubOptions[0].id)
          this.valueSubject = this.SubOptions[0].id
          this.getlevelsData(1)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    search (id) {
      this.SubOptions.map((item, i) => {
        if (item.id == id) {
          this.subInfo = item
          this.getlevelsData()
        }
      })
    },
    getlevelsData (num) {
      this.$http.get('/api/getSubjectLevelsGroup?subject_id='+(num==1?this.valueSubject:this.subInfo.id)).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.levelOptions = res.data.data
          this.valueLevel = this.levelOptions[0].id
          if(num==1){
            this.getCourseData()
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    getCourseData () {
      this.$http.post('/api/getCoursesSchedule',{
        time_diff:this.utils.timeZone(),
        pagesize:this.pageSize,
        page:this.pageNum,
        subject_id:this.valueSubject,
        level_group_id:this.valueLevel,
        weekday:this.valueWeek,
        frequency:this.valueFrequency
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          if(res.data.data.datas){
            this.courseData = this.courseData.concat(res.data.data.datas)
          }
          
          this.total = res.data.data.total
          this.seach = res.data.data.seach
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getCourseData()
    },
		loading() {
        if (document.body.scrollTop + document.documentElement.scrollTop + document.documentElement.clientHeight >= document.body.clientHeight) {
            if (!document.querySelector('.loading')) {
                let load = document.createElement('div');/*创建加载子元素*/ 
                load.className = 'loading';
                document.querySelector('.courseList').appendChild(load);/*添加加载子元素，，创建的div的class名，这里必须一致*/
                  setTimeout(() => {
                        document.querySelector('.courseList').removeChild(load);/*移除加载块*/ 
                        if(this.pageNum <= parseInt(this.total/10)){                                                                 
                          this.pageNum++; //页码计数器，默认为1
                          this.getCourseData(); //调用自己的方法加载数据，将页码计数器传到后端，实现分页获取
                        }
                    
                  }, 300);/*刷新追加新的内容*/
            }
        }
    },
    openFilter () {
      this.isShow = !this.isShow
    },
    apply(){
      this.isShow = false
      this.courseData = []
      this.pageNum = 1
      this.getCourseData ()
    },
    reset(){
      this.valueSubject = ''
      this.valueLevel = ''
      this.valueWeek = []
      this.valueFrequency = ''
    }
  }
}
</script>
<style lang="less" scoped>
  #app{
    height: 100%;
  }
  .courseMobile{
    width: 100vw;
    margin: 0 auto;
    background: #fff;
    .el-header{
        width: 100%;
        height:80px!important;
        padding:0;
        border-bottom:1px solid #E0E0E0;
        .head-top{
          width:100vw;
          height:100%;
          margin:0 auto;
          display: flex;
          align-items: center;
        }
        .logo {
          height: 50px;
          padding-left:20px;
          img{
            width:100%;
            height:100%;
          }
        }
    }
    .el-main{
      padding:0;
      width:100vw;
      // display: flex;
      // align-items: center;
      // flex-direction: column;
      // justify-content:center;
      h3{
        font-size:28px;
        color:#3B495E;
        font-weight: 500;
        padding:28px 0 25px 20px;
      }
      .filtersBtn{
        width:100vw;
        height: 40px;
        display: flex;
        button{
          flex:1;
          height: 100%;
          margin:0 20px;
          background: #F2F2F2;
          border: 1px solid #E0E0E0;
          font-size: 16px;
          border-radius: 12px;
          &:hover{
            color:#3B495E;
          }
          .icon-filter{
            width:15px;
            height:14px;
            display:inline-block;
            margin-right:20px;
            background: url('../assets/Filters.png') center center no-repeat;
            background-size:100% 100%;
          }
        }
      }
      .popoverBox{
        width:100vw;
        height:100vh;
        position: fixed;
        top:0;
        background: rgba(59, 73, 94, 0.25);
        box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
        .searchBox{
          width:100vw;
          height:500px;
          position: fixed;
          bottom:0;
          background: #FFFFFF;
          box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          z-index:111;
          .btnBox{
            display: flex;
            align-items: center;
            justify-content: space-between;
            h3{
              font-size: 16px;
              color: #3B495E;
              padding: 0;
            }
            p{
              font-size: 14px;
              color: #FA7B5E;
            }
          }
          >div{
            padding:0 20px;
            margin:17px 0 14px;
            border-right: 1px solid #E0E0E0;
            &:nth-child(4n){
              border:none;
            }
            p{
              color: #BDBDBD;
              font-size:14px;
            }
            .el-checkbox{
              margin-right:0;
              width:50%;
              margin-top:10px;
              font-size:16px;
            }
            .el-select{
              width:100%;
              margin-top:10px;
              /deep/ .el-input__inner{
                // border:none;
                font-size: 16px;
                color: #3B495E;
                // padding:0;
              }
            }
          }
          .el-button{
            width: 100%;
            height: 40px;
            background: #FA7B5E;
            border-radius: 50px;
            font-size: 16px;
            color:#fff;
            bottom: 0;
          }
        }
      }
    }
    .mainContent{
      width:100vw;
      .courseList{
        width:100vw;
        .listInfo{
          margin-bottom:20px;
          display: flex;
          margin: 20px;
          .courseTitle{
            flex:1;
            padding:10px 15px;
            background: #FFFFFF;
            border: 1px solid #E0E0E0;
            border-radius: 12px;
            .subject_img{
              display: flex;
              align-items: center;
              justify-content: space-between;
              p{
                display: flex;
                align-items: center;
                font-size: 16px;
                color: #3B495E;
                img{
                  width:38px;
                  height: 38px;
                  margin-right:10px;
                }
              }
              span{

                i{
                  font-style: normal;
                  display: block;
                  font-size: 12px;
                  color: #BDBDBD;
                  text-align: right;
                  margin-bottom: 5px;
                }
              }
            }
            >div{
              margin: 10px 0;
              i{
                font-style: normal;
                font-size: 12px;
                color: #BDBDBD;
                text-align: right;
              }
            }
            .perCourse{
              display: flex;
              align-items: flex-end;
              >div{
                flex:1;
                p{
                  line-height: 24px;
                  i{
                    font-style: normal;
                    color: #BDBDBD;
                    font-size: 12px;
                  }
                  b{
                    color:#FD6540;
                  }
                }
              }
              .flex_center{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                p{
                  height:25px;
                  margin-right:10px;
                  img{
                    height:100%;
                  }
                }
              }
            }
          }
        }
      }
    }
    .el-footer{
      text-align: center;
      line-height: 60px;
      margin-top:100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/courseMobile.vue